import { defaultTitleCard } from './defaultShapes/title';
import { generateFactory } from './generate-factory';
import { generateTitleCardId } from './generate-ids';

export const generateTitleCard = generateFactory(
    defaultTitleCard,
    generateTitleCardId
);
